import React from 'react';
import { JdsButton } from '../../../components/jds/JdsButton';
import { JdsSearchInput } from '../../../components/jds/JdsSearchInput';
import { PlusIcon } from '../../../components/jds/icons';

export function Actions({ filterText, onFilter, onClear, onAddClick }) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'var(--space-8)',
      }}
    >
      <JdsSearchInput
        id="offer-name-search"
        placeholder="Buscar por nome"
        filterText={filterText}
        onFilter={onFilter}
        onClear={onClear}
      />
      <JdsButton onClick={onAddClick} aria-label="Nova oferta">
        Nova oferta
        <PlusIcon />
      </JdsButton>
    </div>
  );
}
